import PropTypes from 'prop-types';
import GS from '../../grafsync/grafsync';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { withStyles } from '@material-ui/core/styles';
import { Component, default as React } from 'react';
import Errored from '../Errored';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';
import { globalStyles as styles, gstheme } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import { Typography } from '@material-ui/core';

class SystemMaintenance extends Component {

  constructor(props) {
    super(props);
    const startTime = props.user.adminWindow && props.user.adminWindow.startTime ? props.user.adminWindow.startTime : Date.now() + 3600000;
    const endTime = props.user.adminWindow && props.user.adminWindow.endTime ? props.user.adminWindow.endTime : Date.now() + 7200000;
    this.state = {
      startTime,
      endTime,
      initialStartTime: props.user.adminWindow && props.user.adminWindow.startTime ? startTime : null,
      initialEndTime: props.user.adminWindow && props.user.adminWindow.endTime ? endTime : null
    };
  }

  setStartTime = (dateTime) => {
    const date = new Date(dateTime);
    this.setState({ startTime: date.valueOf() });
  };

  setEndTime = (dateTime) => {
    const date = new Date(dateTime);
    this.setState({ endTime: date.valueOf() });
  };

  clearWindow = async () => {
    try {
      await GS.setMaintenanceWindow(0, 0);
    }
    catch (e) {
      this.setState({
        isErrored: {
          message: "Cannot clear maintenance window."
        }
      });
    }
  };

  applyWindow = async () => {
    try {
      await GS.setMaintenanceWindow(this.state.startTime, this.state.endTime);
    }
    catch (e) {
      this.setState({
        isErrored: {
          message: "Cannot set maintenance window."
        }
      });
    }
  };

  render() {

    const { isErrored, startTime, endTime, initialStartTime, initialEndTime } = this.state;
    const valid = endTime > startTime && startTime > Date.now() + 3600000
      && !(startTime === initialStartTime && endTime === initialEndTime);

    if (isErrored) return <Errored data={isErrored} />;

    return (
      <TitledPanel height="full" dataTest="maintenance-window" fontSize="large" title="Maintenance Window">
        <Grid container>
          <Grid item xs={12} md={6}>
            <TitledPanel title="Starts At" margin={false}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDateTimePicker
                  data-test="start-time"
                  style={{
                    background: startTime === initialStartTime ? gstheme.palette.secondary.main : "white",
                    marginTop: 0
                  }}
                  disablePast={true}
                  variant="dialog"
                  format="yyyy/MM/dd HH:mm"
                  ampm={false}
                  margin="dense"
                  id="start-time"
                  inputVariant="outlined"
                  value={startTime}
                  onChange={this.setStartTime}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
              {startTime && startTime !== initialStartTime &&
                (startTime < (Date.now() + 3600000)) &&
                <Typography data-test="invalid-time" variant="body2" style={{ fontSize: '12px', color: '#DD2C00' }}>The start time must be at least one hour ahead.</Typography>}
            </TitledPanel>
          </Grid>
          <Grid item xs={12} md={6}>
            <TitledPanel title="Ends At" margin={false}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDateTimePicker
                  data-test="end-time"
                  style={{
                    background: endTime === initialEndTime ? gstheme.palette.secondary.main : "white",
                    marginTop: 0
                  }}
                  disablePast={true}
                  variant="dialog"
                  format="yyyy/MM/dd HH:mm"
                  margin="dense"
                  id="end-time"
                  ampm={false}
                  inputVariant="outlined"
                  value={endTime}
                  onChange={this.setEndTime}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </TitledPanel>
          </Grid>
        </Grid>
        <div style={{ float: 'right', marginTop: 40, marginRight: 10 }}>
          <span style={{ marginRight: 10 }}>
            <SecondaryButton onClick={this.clearWindow}>Clear</SecondaryButton>
          </span>
          <PrimaryButton disabled={!valid} onClick={this.applyWindow}>Apply</PrimaryButton>
        </div>
      </TitledPanel>
    );
  }
}

SystemMaintenance.propTypes = {
  user: PropTypes.object,
  classes: PropTypes.object
};

export default withStyles(styles)(SystemMaintenance);